import script from "./FolderTopMatter.vue?vue&type=script&setup=true&lang=ts"
export * from "./FolderTopMatter.vue?vue&type=script&setup=true&lang=ts"

import "./FolderTopMatter.vue?vue&type=style&index=0&id=087bdb11&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-087bdb11"]])

export default __exports__